/**
 * Phase background stripes shown only for the selected phase (SVG: opacity 0→1).
 * A diagonal-stripe bluelight wash spanning the phase, from START_Y to the
 * bottom of the scene.
 */
import { START_Y } from '@/store/remapStore';
import { cssVar } from '../../draw/palette';
import { roundRect, stripePattern } from '../../draw/shapes';
import type { SceneContext } from '../../engine/SceneContext';

export function drawSelectedPhaseBackground(
  ctx: CanvasRenderingContext2D,
  scene: SceneContext,
): void {
  const { map, io } = scene;
  if (map.selectedContext !== 'phase' || !map.selectedId) {
    return;
  }
  const phase = io.phases.find((p) => p.id === map.selectedId);
  if (!phase) {
    return;
  }
  const x = scene.screenX(map.phaseStart(phase));
  const w = map.scaleX(phase.duration);

  const pattern = stripePattern(ctx);
  ctx.save();
  if (pattern) {
    ctx.fillStyle = pattern;
  } else {
    ctx.globalAlpha = 0.3;
    ctx.fillStyle = cssVar('--color-bluelight-300', '#7CD4FD');
  }
  roundRect(ctx, x, START_Y, w, Math.max(0, scene.height - START_Y), 4);
  ctx.fill();
  ctx.restore();
}
